import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const February = () => {
    return (
        <Fragment>{SkipDays(7, 6, [])}</Fragment>  
    )
}